module.exports = __webpack_public_path__ + "img/map_search_info_icon01.fc7fee39.svg";